function qtyMinus(el) {
  var $input = jQuery(el).parent().find('input');
  var $inputValue = parseInt($input.val());
  if ($inputValue <= 2) {
    jQuery(el).removeClass('active');
  }

  var count = parseInt($input.val()) - 1;
  count = count < 1 ? 1 : count;
  $input.val(count);
  $input.change();
  qtyButton(el, parseInt(count));
}

function qtyPlus(el) {
  var $input = jQuery(el).parent().find('input');
  var $inputValue = parseInt($input.val());
  if ($inputValue <= 1) {
    jQuery(el).prevAll('.minus').addClass('active');
  }
  var count = parseInt($input.val()) + 1;
  $input.val(count);
  $input.change();
  qtyButton(el, parseInt(count));
}

function qtyChange(el) {
  let count = parseInt(jQuery(el).val());
  if (count < 1 || isNaN(count)) {
    var $input = jQuery(el).parent().find('input');
    $input.val(1);
    $input.change();
    count = 1;
  }
  qtyButton(el, count);
}

function qtyKeyUp(el) {
  let count = parseInt(el.value);
  if (count < 1) {
    var $input = jQuery(el).parent().find('input');
    $input.val(1);
    $input.change();
    count = 1;
  }
  qtyButton(el, count);
}

function qtyButton(el, qty) {
  jQuery(el)
    .parent()
    .parent()
    .parent()
    .find('.add_to_cart_button')
    .attr('data-quantity', qty);
}

function qtyMinusUpdate(el) {
  var $input = jQuery(el).parent().find('input');
  var $inputValue = parseInt($input.val());
  if ($inputValue <= 2) {
    jQuery(el).removeClass('active');
  }

  var count = parseInt($input.val()) - 1;
  count = count < 1 ? 1 : count;
  $input.val(count);
  $input.change();
}

function qtyPlusUpdate(el) {
  var $input = jQuery(el).parent().find('input');
  var $inputValue = parseInt($input.val());
  if ($inputValue <= 1) {
    jQuery(el).prevAll('.minus').addClass('active');
  }
  var count = parseInt($input.val()) + 1;
  $input.val(count);
  $input.change();
}

function qtyChangeUpdate(el, orgQty) {
  let count = parseInt(jQuery(el).val());
  if (count < 1 || isNaN(count)) {
    var $input = jQuery(el).parent().find('input');
    $input.val(1);
    $input.change();
    count = 1;
  }
  jQuery(el)
    .parent()
    .parent()
    .parent()
    .find('.add_to_cart_button.update-cart')
    .attr('data-quantity', count - orgQty);
  if (count - orgQty === 0) {
    jQuery(el)
      .parent()
      .parent()
      .parent()
      .find('.add_to_cart_button.update-cart')
      .attr('disabled', 'disabled');
  } else {
    jQuery(el)
      .parent()
      .parent()
      .parent()
      .find('.add_to_cart_button.update-cart')
      .removeAttr('disabled');
  }
}

function qtyKeyUpUpdate(el, orgQty) {
  let count = parseInt(el.value);
  if (count < 1) {
    var $input = jQuery(el).parent().find('input');
    $input.val(1);
    $input.change();
    count = 1;
  }
  jQuery(el)
    .parent()
    .parent()
    .parent()
    .find('.add_to_cart_button.update-cart')
    .attr('data-quantity', count - orgQty);
  if (count - orgQty === 0) {
    jQuery(el)
      .parent()
      .parent()
      .parent()
      .find('.add_to_cart_button.update-cart')
      .attr('disabled', 'disabled');
  } else {
    jQuery(el)
      .parent()
      .parent()
      .parent()
      .find('.add_to_cart_button.update-cart')
      .removeAttr('disabled');
  }
}

function incrementPreBasketBlock() {
  window.block_pre_basket++;
}

function drawBasketRemoveOnClick(el) {
  jQuery(el).addClass('loading');
}
// window.almComplete = function(alm){
//   qtyMinus();
//   qtyPlus();
// };

jQuery(document).ready(function ($) {
  // $('.quantity-wrapper .qty').each(function () {
  //   var $inputValue = parseInt($(this).val());
  //   $boom = $(this);

  //   console.log('Input value if ' + $inputValue + ' ' + $boom);
  //   if ($inputValue <= 1) {
  //     $(this).addClass('boom');
  //     console.log('Input value if ' + $inputValue + ' ' + $boom);
  //   }
  // });

  // qtyMinus();
  // qtyPlus();

  $('.b2bwhs_bulkorder_form_container_content_line_qty_container .minus').click(
    function () {
      console.log('minus');
      var $input = $(this).parent().find('input');
      var count = parseInt($input.val()) - 1;
      var $inputValue = parseInt($input.val());
      if ($inputValue <= 2) {
        $(this).removeClass('active');
      }
      count = count < 1 ? 0 : count;
      $input.val(count);
      $input.change();
      // $("#update_basket").click();
      return false;
    }
  );

  $('.b2bwhs_bulkorder_form_container_content_line_qty_container .plus').click(
    function () {
      console.log('plus');
      var $input = $(this).parent().find('input');
      var $inputValue = parseInt($input.val());
      if ($inputValue <= 1) {
        $(this).prevAll('.minus').addClass('active');
      }
      $input.val(parseInt($input.val()) + 1);
      $input.change();
      // $("#update_basket").click();
      return false;
    }
  );
  //Move PO field to top of form
  if ($('#pk_customer_purchase_order_number_field')) {
    if ($('#find_val_shipping').length) {
      $('#pk_customer_purchase_order_number_field').insertBefore(
        '#find_val_shipping'
      );
    } else if ($('#shipping_company_field').length) {
      $('#pk_customer_purchase_order_number_field').insertBefore(
        '#shipping_company_field'
      );
    }
  }
  if ($('#billing_phone_field').length && $('#shipping_phone_field').length) {
    $('#billing_phone_field').insertBefore('#shipping_phone_field');
  }
  // Set max length on PO inout field
  $('#pk_customer_purchase_order_number').attr('maxlength', '61');
});
